import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const initialState = {
  gpsData: null,
  status: 'idle',
  error: null,
};

const gpsDataSlice = createSlice({
  name: 'gpsData',
  initialState,
  reducers: {
    setGPSData: (state, action) => {
      // Ensure payload type matches IGPSData[]
      state.gpsData = action.payload;
      state.status = 'succeeded';
    },
    setError: (state, action) => {
      state.error = action.payload;
      state.status = 'failed';
    },
    setLoading: (state) => {
      state.status = 'loading';
    },
  },
});

export const { setGPSData, setError, setLoading } = gpsDataSlice.actions;
export default gpsDataSlice.reducer;
